<template>
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <img src="~assets/img/logo-side-menu.png" alt="Arrow Logistics" />
          <p>
            <strong class="font-bold">{{ $user.profile.full_name }}</strong><br />
            <small>{{ $user.profile.company_name }}</small><br>

            <div
              class="m-t-md navigation-disabled-warning"
              role="alert"
              v-if="$user.isDisabled"
              data-toggle="modal" data-target=".modal-disabled-help">
              <i class="fa fa-exclamation-triangle"></i> Account Disabled
            </div>
          </p>
        </li>

        <router-link :to="{ name: 'dashboard' }" tag="li" exact>
          <a>
            <i class="far fa-fw fa-home"></i>
            <span class="nav-label">Dashboard</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'jobs.requests' }" tag="li" v-if="$user.canManageJobRequests">
          <a>
            <i class="far fa-fw fa-question-circle"></i>
            <span class="nav-label">Job Requests</span>
            <span v-if="pendingJobRequests" class="label pull-right">{{ pendingJobRequests }}</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'job-board.index' }" tag="li" v-if="$user.canManageJobBoard">
          <a>
            <i class="far fa-fw fa-bullhorn"></i>
            <span class="nav-label">Job Board</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'jobs.index' }" tag="li" v-if="$user.canManageJobs">
          <a>
            <i class="far fa-fw fa-truck"></i>
            <span class="nav-label">Jobs</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'loads.requests' }" tag="li" v-if="$user.isCarrier">
          <a>
            <i class="far fa-fw fa-question-circle"></i>
            <span class="nav-label">Load Requests</span>
            <span v-if="loadRequests" class="label pull-right">{{ loadRequests }}</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'locations.index' }" tag="li" v-if="$user.canManageLocations">
          <a>
            <i class="far fa-fw fa-map-signs"></i>
            <span class="nav-label">Locations</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'map' }" tag="li" v-if="$user.canSeeMap">
          <a>
            <i class="far fa-fw fa-map-marked"></i>
            <span class="nav-label">Map</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManageTrucks" :to="{ name: 'trucks.index' }" tag="li">
          <a>
            <i class="far fa-fw fa-truck-container"></i>
            <span class="nav-label">My Trucks</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManageDrivers" :to="{ name: 'drivers.index' }" tag="li">
          <a>
            <i class="far fa-id-card"></i>
            <span class="nav-label">My Drivers</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManageLoads" :to="{ name: 'loads.index' }" tag="li">
          <a>
            <i class="far fa-fw fa-clipboard-list"></i>
            <span class="nav-label">Loads</span>
            <span class="label pull-right" style="margin:0 1px 0 1px" v-if="loadsWithIssues">{{ loadsWithIssues }}</span>
            <span class="label pull-right" style="margin:0 1px 0 1px" v-if="withdrawnLoads">{{ withdrawnLoads }}</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManageLoadChecks" :to="{ name: 'load-check.index' }" tag="li">
          <a>
            <i class="far fa-fw fa-image"></i>
            <span class="nav-label">Load Check</span>
            <span v-if="pendingLoadChecks" class="label pull-right">{{ pendingLoadChecks }}</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManageInvoices" :to="{ name: 'invoices.index' }" tag="li">
          <a>
            <i class="far fa-fw fa-file-invoice"></i>
            <span class="nav-label">Invoices</span>
            <span class="label pull-right" v-if="outstandingInvoices">{{ outstandingInvoices }}</span>
          </a>
        </router-link>

        <router-link v-if="$user.canManagePayments" :to="{ name: 'payments.index' }" tag="li">
          <a>
            <i class="far fa-fw fa-money-check-alt"></i>
            <span class="nav-label">Payments</span>
            <span v-if="paymentsNeedingInvoice" class="label pull-right">{{ paymentsNeedingInvoice }}</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'reports.index' }" v-if="$user.canManageReports" tag="li">
          <a>
            <i class="far fa-fw fa-analytics"></i>
            <span class="nav-label">Reports</span>
          </a>
        </router-link>


        <li v-if="$user.canManageUsers">
          <a href="#">
            <i class="far fa-fw fa-users"></i>
            <span class="nav-label">Users </span>
            <span class="fa arrow"></span>
            <span v-if="usersPendingVerification" class="label pull-right" style="margin-right: 10px">{{ usersPendingVerification }}</span>
          </a>
          <ul class="nav nav-second-level collapse">
            <li>
              <router-link :to="{ name: 'users.index' }">Active Users</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'users.pending' }">
              Pending Users
              </router-link>
            </li>
          </ul>
        </li>

        <li v-if="$user.canManageSettings">
          <a href="#">
            <i class="far fa-fw fa-cog"></i>
            <span class="nav-label">Settings</span><span class="fa arrow"></span>
          </a>
          <ul class="nav nav-second-level collapse">
            <li><router-link :to="{ name: 'settings.system' }">System Settings</router-link></li>
          </ul>
        </li>

        <li>
          <li :class="{ 'active': active('account') }">
            <a href="#">
              <i class="far fa-fw fa-user-circle"></i>
              <span class="nav-label">Account</span><span class="fa arrow"></span>
            </a>
            <ul class="nav nav-second-level collapse" :class="{ 'in': active('account') }" :aria-expanded="active('account')">
              <router-link tag="li" :to="{ name: 'account.settings' }"><a>Account Settings</a></router-link>
              <router-link v-if="$user.isMaster" tag="li" :to="{ name: 'account.users' }"><a>Account Users</a></router-link>
              <router-link tag="li" :to="{ name: 'account.notifications' }" v-if="$user.isNotAdmin">
                <a>Notifications</a>
              </router-link>
            </ul>
          </li>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
  import { startsWith, trimStart } from 'lodash'
  import { mapActions, mapState } from 'vuex'
  import $ from 'jquery'
  import 'metismenu'
  import 'jquery-slimscroll'

  export default {
    watch: {
      '$route' () {
        if ($('body').hasClass('mini-navbar') && $('body').hasClass('body-small')) {
          $('body').toggleClass('mini-navbar')

          this.toggleMenu()
        }
      }
    },

    created () {
      this.getNavigationCounts()

      this.$bus.$on('updateNavigation', this.getNavigationCounts)

      this.$echo.private(this.privateChannel).stopListening('NavigationCountsUpdated')

      this.$echo.private(this.privateChannel).listen('NavigationCountsUpdated', event => {
        this.getNavigationCounts()
      })
    },

    mounted () {
      // Bind Metis Menu for toggling open dropdowns.
      $('#side-menu').metisMenu()

      // Bind slim scroll, needs to be done inside of a timeout because Firefox
      // shows a scrollbar if it isn't.
      setTimeout(() => {
        $('.sidebar-collapse').slimScroll({
          height: '100%',
          railOpacity: 0.9
        })
      }, 0)

      // Bind click handler for minimizing the navigation.
      $('.navbar-minimalize').on('click', event => {
        event.preventDefault()

        $('body').toggleClass('mini-navbar')

        this.toggleMenu()
      })
    },

    computed: {
      ...mapState('app', ['navigationCounts']),

      pendingJobRequests () {
        return this.navigationCounts.pending_job_requests || 0
      },

      loadRequests () {
        return this.navigationCounts.load_requests || 0
      },

      pendingLoadChecks () {
        return this.navigationCounts.pending_load_checks || 0
      },

      usersPendingVerification () {
        return this.navigationCounts.users_pending_verification || 0
      },

      loadsWithIssues () {
        return this.navigationCounts.loads_with_issues || 0
      },

      paymentsNeedingInvoice () {
        return this.navigationCounts.payments_needing_invoice || 0
      },

      withdrawnLoads () {
        return this.navigationCounts.withdrawn_loads || 0
      },

      outstandingInvoices () {
        return this.navigationCounts.outstanding_invoices || 0
      },

      privateChannel () {
        return `navigation`
      }
    },

    methods: {
      ...mapActions('app', ['getNavigationCounts']),

      /**
       * Toggle the menu.
       *
       * @return void
       */
      toggleMenu () {
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
          $('#side-menu').hide()

          setTimeout(() => {
            $('#side-menu').fadeIn(400)
          }, 200)
        } else if ($('body').hasClass('fixed-sidebar')) {
          $('#side-menu').hide()

          setTimeout(() => {
            $('#side-menu').fadeIn(400)
          }, 200)
        } else {
          $('#side-menu').removeAttr('style')
        }
      },

      /**
       * Determine if the current route path starts with a given path.
       *
       * @param string path
       *
       * @return boolean
       */
      active (path) {
        return startsWith(trimStart(this.$route.path, '/'), path)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Navigation.vue?cbe53790